import React, { Component } from 'react';
import ReviewAndConfirm from '../../components/BookingFlow/ReviewAndConfirm';
import * as actions from '../../redux/actions/index';
import { convertDateToDifferentTZ } from '../../utility/utility';
import { connect } from 'react-redux';
import { routes } from '../../utility/constants/constants';
import moment from 'moment'
import { withRouter } from 'react-router-dom';

const cloneDeep = require('clone-deep');

class ReviewAndConfirmContainer extends Component {

    componentDidMount() {
        // this.props.isBlocking(true);
        console.log(this.props.bookingData);

        const servicesIds = [];

        // this.props.bookingData.booking_services_attributes.map(service =>
        //     servicesIds.push(service.service_id)
        // )
        let servicesIdsString = ''
        this.props.bookingData.booking_services_attributes.map(service => {
            servicesIdsString = servicesIdsString.concat('service_ids[]=' + service.service_id + '&')
        })

        this.props.getUserFavoriteHerosList(servicesIdsString, this.props.bookingData.address_attributes.latitude, this.props.bookingData.address_attributes.longitude);
        console.log(this.props.location.state);
    }

    // componentWillUnmount = () => {
    //     console.log(this.props.history);
    //     if (this.props.history.location.pathname === routes.LOCATION_AND_PAYMENT_DETAIL) {
    //         this.props.history.push({
    //             pathname: routes.LOCATION_AND_PAYMENT_DETAIL,
    //             state: { ...this.props.location.state }
    //         });
    //     }
    // }
    addReviewAndConfirm = (values) => {
        let booking = cloneDeep(values);
        // this.props.isBlocking(false);
        booking = { ...this.props.bookingData, ...booking }

        if (!booking.asap) {
            // booking.scheduled_at = convertDateToDifferentTZ(booking.scheduled_at, booking.address_attributes.timeZone);
        } else {
            delete booking.scheduled_at;
        }

        // The favorite-heroes control is a checkbox group, so its value is an
        // array. Empty means the customer unticked their AV HERO: send an
        // explicit null so the server clears it, rather than a NaN that only
        // happens to serialize as null.
        const pickedHero = Array.isArray(booking.preferred_provider_id)
            ? booking.preferred_provider_id[booking.preferred_provider_id.length - 1]
            : booking.preferred_provider_id;
        booking.preferred_provider_id = pickedHero ? parseInt(pickedHero) : null;
        booking.scheduled_at = moment(booking.scheduled_at).format('YYYY-MM-DDTHH:mm::ss[Z]')
        delete booking.asap;
        delete booking.services;
        delete booking.address;
        // The flow doubles as the edit UI: when it was entered from a pending
        // job's "Edit job" button, submit the edit endpoint instead of creating
        // a new job.
        const editingBookingId = booking.editing_booking_id;
        delete booking.editing_booking_id;
        if (editingBookingId) {
            this.props.editBookingDetails(editingBookingId, booking);
        } else {
            this.props.createBooking(booking);
        }
    }

    // In-page Back to step 2. The only value entered on this screen is the
    // favorite-hero selection; keep it so it is still checked on return.
    goBackToLocation = (values) => {
        const bookingData = { ...this.props.bookingData };
        if (values && values.preferred_provider_id && values.preferred_provider_id.length) {
            bookingData.preferred_provider_id = parseInt(values.preferred_provider_id);
        }
        this.props.updateBookingState(bookingData);
        this.props.history.push(routes.LOCATION_AND_PAYMENT_DETAIL);
    }

    render() {
        return (
            <ReviewAndConfirm
                history={this.props.history}
                user={this.props.user}
                createBookingLoading={this.props.createBookingLoading}
                bookingData={this.props.bookingData}
                addReviewAndConfirm={this.addReviewAndConfirm}
                goBackToLocation={this.goBackToLocation}
                services={this.props.services}
                settings={this.props.settings}
                userFavoriteHerosList={this.props.userFavoriteHerosList ? this.props.userFavoriteHerosList : []}
            />
        )
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
        services: state.configReducer.services,
        userFavoriteHerosList: state.clientOrHeroReducer.userFavoriteHerosList,
        createBookingLoading: state.clientOrHeroReducer.createBookingLoading,
        bookingData: state.clientOrHeroReducer.bookingData,
        settings: state.configReducer.settings,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createBooking: (data) => dispatch(actions.createBooking(data)),
        editBookingDetails: (id, data) => dispatch(actions.editBookingDetails(id, data)),
        updateBookingState: (data) => dispatch(actions.updateBookingState(data)),
        getUserFavoriteHerosList: (serviceIds, lat, lng) => dispatch(actions.getUserFavoriteHerosList(serviceIds, lat, lng))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReviewAndConfirmContainer));